/**
 * Stacked Suggestions Block Renderer
 * Renders a stacked list of suggestions that can trigger actions
 */

import React from "react";
import { StackedSuggestions } from "@strivelabs/ui-blocks";
import type { UIBlock, UIActionEvent } from "@/types/ui-blocks";

export interface StackedSuggestionsBlockRendererProps {
  block: UIBlock;
  onUIAction: (event: UIActionEvent) => void;
  /** When true, the component is disabled */
  readOnly?: boolean;
}

export function StackedSuggestionsBlockRenderer({ 
  block,
  onUIAction,
  readOnly = false
}: StackedSuggestionsBlockRendererProps) {
  if (block.type !== 'stacked_suggestions') return null;

  // Don't render suggestions in read-only mode
  if (readOnly) return null;

  const { content } = block;

  // Guard against malformed LLM responses (content: null, missing suggestions, empty array)
  if (!content?.suggestions?.length) return null;

  const handleSelect = (text: string, prefillOnly?: boolean) => {
    // Emit UI action event for tracking
    onUIAction({
      type: "ui_action",
      component: "stacked_suggestions",
      label: "Suggestion Selected",
      state: { text, prefillOnly: prefillOnly ?? false }
    });
  };

  return (
    <StackedSuggestions
      suggestions={content.suggestions}
      onSelect={handleSelect}
    />
  );
}
